/* eslint-disable no-underscore-dangle,@typescript-eslint/naming-convention */
import { COLORS } from '@bumble/app/theme/colors';
import { TypographyOptions } from '@mui/material/styles/createTypography';

class SPACING {
  static STD = '1.0px';
  static TIGHT = '0.50px';
  static REALLYTIGHT = '0.40px';
  static SUPERTIGHT = '0.25px';
  static ULTRATIGHT = '0.15px';
}

class FONTSIZE {
  static H1 = '3.5rem';
  static H2 = '3rem';
  static H3 = '2.4rem';
  static H4 = '2rem';
  static H5 = '1.4rem';
  static H6 = '1.2rem';
}

class FONTWEIGHT {
  static NORMAL = 'normal';
  static BOLD = 'bold';
  static _400 = '400';
  static MEDIUM = '500';
  static _700 = '700';
  static HEAVY = '800';
}

const FONTFAMILY = ['Urbanist', 'sans-serif'].join(',');

// ===========================================================================
// ---------------------------------------------------------------------------
//
// typography
//
// ---------------------------------------------------------------------------
// ===========================================================================
export const typography: TypographyOptions = {
  // Default
  fontFamily: FONTFAMILY,
  fontSize: 16,
  htmlFontSize: 10,

  // h1
  h1: {
    fontFamily: FONTFAMILY,
    color: COLORS.BLACK,
    fontSize: FONTSIZE.H1,
    fontWeight: FONTWEIGHT.MEDIUM,
    letterSpacing: '-0.05rem',
  },

  // h2
  h2: {
    fontFamily: FONTFAMILY,
    color: COLORS.BLACK,
    fontSize: FONTSIZE.H2,
    fontWeight: FONTWEIGHT.MEDIUM,
    letterSpacing: 0,
  },

  // h3
  h3: {
    fontFamily: FONTFAMILY,
    color: COLORS.BLACK,
    fontSize: FONTSIZE.H3,
    fontWeight: FONTWEIGHT.BOLD,
    letterSpacing: '0.025rem',
  },

  // h4
  h4: {
    fontFamily: FONTFAMILY,
    color: COLORS.BLACK,
    fontSize: FONTSIZE.H4,
    fontWeight: FONTWEIGHT.BOLD,
    letterSpacing: 0,
  },

  // h5
  h5: {
    fontFamily: FONTFAMILY,
    color: COLORS.BLACK,
    fontSize: FONTSIZE.H5,
    fontWeight: FONTWEIGHT.BOLD,
    letterSpacing: '0.015rem',
  },

  // h6
  h6: {
    fontFamily: FONTFAMILY,
    color: COLORS.BLACK,
    fontSize: FONTSIZE.H6,
    fontWeight: FONTWEIGHT.BOLD,
    letterSpacing: SPACING.STD,
  },

  subtitle1: {
    fontSize: '1.6rem',
    fontWeight: FONTWEIGHT.BOLD,
    letterSpacing: '.015rem',
  },

  caption: {
    fontSize: '1.2rem',
    fontWeight: FONTWEIGHT.MEDIUM,
    letterSpacing: '.04rem',
    lineHeight: '2rem',
  },

  subtitle2: {
    fontSize: '1.4rem',
    fontWeight: FONTWEIGHT.BOLD,
    letterSpacing: '.015rem',
  },

  body1: {
    fontSize: '1.6rem',
    letterSpacing: '.05rem',
    fontWeight: FONTWEIGHT.MEDIUM,
  },

  body2: {
    fontSize: '1.4rem',
    fontWeight: FONTWEIGHT.MEDIUM,
    lineHeight: '2.1rem',
    letterSpacing: '.025rem',
  },

  // Button
  button: {
    fontSize: '1.5rem',
  },
};
// . --------------------------------------------------------------------------
// ===========================================================================
